
<tds-folder-tabs *ngIf="loggedAccount.sysAdmin">
    <tds-folder-tab *ngIf="loggedAccount.sysAdmin" style="margin-top: 4px;">
        <button (click)="showThis('sysadmin-batch-check')">Batch Check</button>
    </tds-folder-tab>
    <tds-folder-tab *ngIf="loggedAccount.sysAdmin" style="margin-top: 4px;">
        <button (click)="showThis('sysadmin-set-infomsg')">Set Info Message</button>
    </tds-folder-tab>
    <!-- <tds-folder-tab *ngIf="loggedAccount.sysAdmin" style="margin-top: 4px;">
        <button (click)="showThis('sysadmin-change-globalid')">Change Global ID</button>
    </tds-folder-tab > -->
    <!-- <tds-folder-tab *ngIf="loggedAccount.sysAdmin"style="margin-top: 4px;">
        <button (click)="showThis('sysadmin-set-newemployee')">New Employee</button>
    </tds-folder-tab> -->
    <tds-folder-tab *ngIf="loggedAccount.sysAdmin && loggedAccount.changeAdminAuthority" style="margin-top: 4px;">
        <button (click)="showThis('sysadmin-set-admin')">Edit Admin Level</button>
    </tds-folder-tab>
</tds-folder-tabs>

<div *ngIf="visiblePage === 'sysadmin-batch-check' && loggedAccount.sysAdmin"  style="margin-top: 8px;">
    <sysadmin-batch-check></sysadmin-batch-check>
</div>

<div *ngIf="visiblePage === 'sysadmin-set-infomsg' && loggedAccount.sysAdmin" style="margin-top: 8px;">
    <sysadmin-set-infomsg></sysadmin-set-infomsg>
</div>

<!-- <div *ngIf="visiblePage === 'sysadmin-change-globalid' && loggedAccount.sysAdmin" style="margin-top: 8px;">
    <sysadmin-change-globalid></sysadmin-change-globalid>
</div> -->

<!-- <div *ngIf="visiblePage === 'sysadmin-set-newemployee' && loggedAccount.sysAdmin" style="margin-top: 8px;">
    <sysadmin-set-newemployee></sysadmin-set-newemployee>
</div> -->

<div *ngIf="visiblePage === 'sysadmin-set-admin' && loggedAccount.changeAdminAuthority && loggedAccount.sysAdmin" style="margin-top: 8px;">
    <sysadmin-set-admin></sysadmin-set-admin>
</div>

